import { render, staticRenderFns } from "./goodItem.vue?vue&type=template&id=55802e4e&scoped=true"
import script from "./goodItem.vue?vue&type=script&lang=js"
export * from "./goodItem.vue?vue&type=script&lang=js"
import style0 from "./goodItem.vue?vue&type=style&index=0&id=55802e4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55802e4e",
  null
  
)

export default component.exports